import { onScroll, onResize, getScrollTop, getWidth } from '../utils/window';
import { newElement, slideUp, slideDown } from '../utils/drawing';

/**
 * Header controls.
 */
export default function headerSection() {

  // Menu breakpoint
  const isMobileView = () => {
    return getWidth() < 960;
  }

  // scroll changes
  const header = document.getElementById('header');
  let lastSt = 0;
  let gateHeight = 100;
  onScroll((e) => {
    let st = getScrollTop();
    if (st > lastSt){
      // downscroll code
      if (st > gateHeight) {
        header.classList.add('is-scrolled');
      }
    } else {
      // upscroll code
      if (st <= gateHeight) {
        header.classList.remove('is-scrolled');
      }
    }
    lastSt = st;
  });

  // ------------------------------------------------------------------
  // All menus
  const menuParents = document.querySelectorAll('nav.header_menu li.parent > a');
  const superMenus = document.querySelectorAll('nav.header_menu div.header_new-super-menu');
  const mobileMenu = document.querySelector('nav.header_new-mobile-menu');
  const mobileMenuButton = document.getElementById('mobile-menu-button');

  const menuReset = () => {
    let all = document.querySelectorAll("nav.header_menu *");
    all.forEach(el => {
      el.classList.remove('-is-open');
      el.classList.remove('-is-expanded');
      el.classList.remove('-is-clicked');
    })
  }

  // ------------------------------------------------------------------
  // Header menus
  if (menuParents) {

    const setupMenu = resize => {

      menuReset();

      // Top level items (all events)
      menuParents.forEach(parent => {

        if (!parent.parentNode) return;

        // Click menu parent
        const clickParent = event => {

          event.preventDefault();

          // find super with this ID
          if (superMenus) superMenus.forEach(spm => {
            if (spm.dataset.superMenuId !== parent.parentNode.dataset.menuId) {

              if (spm.classList.contains('-is-open')) {

                spm.classList.add('-is-closing');
  
                setTimeout(() => {
                  spm.classList.remove('-is-closing');
                }, 500);
              }

              spm.classList.remove('-is-open');
              spm.classList.remove('-is-expanded');
            }
          });
          let spm = document.querySelector(`[data-super-menu-id="${parent.parentNode.dataset.menuId}"]`);
          if (spm) {
            spm.classList.toggle('-is-open');

            if (spm.classList.contains('-is-open')) {
              document.querySelector("html").classList.add('is-header-open');
            } else {
              document.querySelector("html").classList.remove('is-header-open');
            }
          }
        }

        // parent.removeEventListener('click', clickParent);
        parent.addEventListener('click', clickParent);

        // Super menu parents (open the supermenu sub menu)
        let superMenuParents = parent.parentNode.querySelectorAll('.header_new-super-menu--parent li.item');
        superMenuParents.forEach(superParent => {

          let eventType = isMobileView() ? 'click' : 'mouseenter';

          const clickSuperParent = event => {

            if (!superParent.classList.contains('-has-subs') || isMobileView()) return; // No sub items, so just click as normal
            
            event.preventDefault();

            superMenus.forEach(s => s.classList.add('-is-expanded'));
            superMenuParents.forEach(smp => smp.classList.remove('-is-clicked'));
            superParent.classList.add('-is-clicked');

            let superId = superParent.dataset.superId;
            let subMenus = document.querySelectorAll(`.header_new-super-menu--subs ul[data-super-id="${superId}"]`);

            // hide all subs
            document.querySelectorAll('.header_new-super-menu--subs ul').forEach(sub => {
              sub.classList.remove('-is-open');
            });

            if (subMenus) subMenus.forEach(sub => {
              sub.classList.add('-is-open');
            });
          }
          superParent.removeEventListener(eventType, clickSuperParent);
          superParent.addEventListener(eventType, clickSuperParent);
        });

        // Exit button
        let superMenuExitButton = parent.parentNode.querySelectorAll('.header_new-super-menu--parent button.super-menu-exit-button');
        superMenuExitButton.forEach(spmeb => {
          spmeb.addEventListener('click', event => {
            mobileMenu.classList.remove('-is-offscreen');
            superMenus.forEach(s => s.classList.remove('-is-open'));
          })
        });

        // Back button
        let superMenuBackButton = parent.parentNode.querySelectorAll('.header_new-super-menu--subs button.super-menu-back-button');
        superMenuBackButton.forEach(spmbb => {
          spmbb.addEventListener('click', event => {
            superMenus.forEach(s => s.classList.remove('-is-expanded'));
          })
        });
      });
    }

    // Reset for resize
    // onResize(() => setupMenu(true));
    setupMenu();
    
    // ------------------------------------------------------------------
    // Mobile menu
    if (mobileMenuButton && mobileMenu) {
      mobileMenuButton.addEventListener('click', event => {

        if (mobileMenu.classList.contains('-is-open')) {
          mobileMenu.classList.remove('-is-open');
          // mobileMenu.classList.remove('-is-offscreen');
          mobileMenuButton.classList.remove('-is-open');
          document.querySelectorAll('.header_new-mobile-menu-submenu').forEach(el => el.classList.remove('is-opened'));
          document.querySelector("html").classList.remove('is-header-open');
        } else {
          mobileMenu.classList.add('-is-open');
          mobileMenuButton.classList.add('-is-open');
          document.querySelector("html").classList.add('is-header-open');
        }
      });
    }

    const mobileMenuParents = mobileMenu !== null ? mobileMenu.querySelectorAll('li.parent') : [];
    mobileMenuParents.forEach(parent => {
      parent.addEventListener('click', event => {
        if (event.target === parent) {
          parent.querySelector('.header_new-mobile-menu-submenu').classList.add('is-opened');
          // mobileMenu.classList.add('-is-offscreen');
        }
      });
    });

    mobileMenu.querySelectorAll('.header_new-mobile-menu-submenu_back').forEach(backButton => {
      backButton.addEventListener('click', event => {
        event.preventDefault();
        event.target.closest('.header_new-mobile-menu-submenu').classList.remove('is-opened');
      });
    });
  }

  // ------------------------------------------------------------------
  // Solutions mobile menu
  const setupSolutionsMenu = () => {

    const solutionsMenu = document.querySelector('.solution-detail_menu');
    const solutionsMenuFooter = document.querySelector('.solution-detail_menu_foot');

    const clickSolutionsMenu = event => {
      if (solutionsMenu.classList.contains('-is-open')) {
          
        solutionsMenu.classList.remove('-is-open');
        slideDown(solutionsMenu.querySelector('ul'), 1000, () => {});
      } else {

        solutionsMenu.classList.add('-is-open');
        slideUp(solutionsMenu.querySelector('ul'), 1000, () => {});
      }
    }

    const clickSolutionsFooter = event => {
      if (solutionsMenu.classList.contains('-is-open')) {
        solutionsMenu.classList.remove('-is-open');
      } else {
        solutionsMenu.classList.add('-is-open');
      }
    }
    
    if (solutionsMenu && isMobileView()) {
      const solutionsMenuHeader = solutionsMenu.querySelector('.solution-detail_menu_head');
      solutionsMenuHeader.addEventListener('click', clickSolutionsMenu);
    } else {
      if (solutionsMenu) {
        const solutionsMenuHeader = solutionsMenu.querySelector('.solution-detail_menu_head');
        solutionsMenuHeader.removeEventListener('click', clickSolutionsMenu);

        if (solutionsMenuFooter) {
          solutionsMenuFooter.addEventListener('click', clickSolutionsFooter);
        }
      }
    }
  }
  onResize(() => setupSolutionsMenu());
  setupSolutionsMenu();


  // ------------------------------------------------------------------
  // Investor news
  (async () => {

    let container = document.querySelector('.hero_investor-news');
    if (!container) return;

    const url = 'https://investors.tesserent.com/site/feed/1.0/ListPageItems.aspx';
    await require('axios').post(
      url,
      {
        categoryid: 199,
        year: new Date().getFullYear()
      }
    )
    .then(function (response) {

      if (!response.data.items) return;

      let index = 0;
      let items = response.data.items;
      let feedContainer = container.querySelector('.hero_investor-news_feed');
      let inTransit = false;

      const firstItem = feedContainer.querySelector('a');
      const itemTemplate = firstItem.parentNode.innerHTML;
      const itemAttributes = firstItem.attributes;

      // autoplay
      let autoplay;
      const startAutoPlay = () => {
        autoplay = setInterval(() => {
          show(index + 1 < (items.length - 1) ? index + 1 : 0);
        }, 8600);
      }

      // show the news item
      const show = (i, first = false) => {
        if (i === index && first === false) return;

        clearInterval(autoplay);

        // transit begin
        const beginTransit = item => {

          inTransit = true;

          let ie = feedContainer.querySelector('a');
          ie.classList.replace('-transit-in', '-transit-out');

          setTimeout(() => {
            completeTransit(item);
          }, 500);
        }

        // transit complete
        const completeTransit = item => {

          feedContainer.innerHTML = '';
          let itemElement = newElement('a', itemAttributes, itemTemplate);
          itemElement.href = item.url;
          itemElement.querySelector('h4').innerHTML = item.title;
        
          let d = new Date(item.effectiveDate);
          let df = new Intl.DateTimeFormat('de-DE', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
          }).format(d);
          itemElement.querySelector('h5.date span').innerHTML = df;

          itemElement.classList.add('-transit-stop');
          feedContainer.appendChild(itemElement);

          setTimeout(() => {
            itemElement.classList.replace('-transit-stop', '-transit-in');
            inTransit = false;
            startAutoPlay();
          }, 5);
        }

        let item = items[i];

        first ? completeTransit(item) : beginTransit(item);

        index = i;
      }

      // remove loading class from container
      container.classList.remove('-loading');

      // hook up arrow buttons
      let prevButton = container.querySelector('.hero_investor-news_nav button:first-child');
      let nextButton = container.querySelector('.hero_investor-news_nav button:last-child');
      prevButton.addEventListener('click', event => {
        if (!inTransit) show(index - 1 > 0 ? index - 1 : 0);
      });
      nextButton.addEventListener('click', event => {
        if (!inTransit) show(index + 1 < (items.length - 1) ? index + 1 : (items.length - 1));
      });

      // show first
      show(index, true);
    })
    .catch(function (error) {
      console.log(error);
    });
  })();

  // Search toggle (desktop)
  const searchButton = document.querySelector('.header_menu .header_menu_search_button button');
  const searchOverlay = document.querySelector('.header_search');
  if (searchButton && searchOverlay) {

    const searchInput = searchOverlay.querySelector('input');
    const logoOffset = document.querySelector('.header_logo').offsetWidth + 44;
    const clickSearchPanel = event => { event.preventDefault(); event.stopPropagation(); }
    const clickOffSearchPanel = () => { toggleSearchPanel(true); }

    const toggleSearchPanel = state => {
      if (!state) {
        searchButton.classList.add('-open');
        searchOverlay.style.left = `${logoOffset}px`;
        searchOverlay.style.opacity = 1;
        searchOverlay.style.pointerEvents = 'all';
        searchOverlay.addEventListener('click', clickSearchPanel);
        document.querySelector('main').addEventListener('click', clickOffSearchPanel);
        searchInput.focus();
      } else {
        searchButton.classList.remove('-open');
        searchOverlay.style.left = '95%';
        searchOverlay.style.opacity = 0;
        searchOverlay.style.pointerEvents = 'none';
        searchOverlay.removeEventListener('click', clickSearchPanel);
        document.querySelector('main').removeEventListener('click', clickOffSearchPanel);
      }
    }
    searchButton.addEventListener('click', event => {
      toggleSearchPanel(searchButton.classList.contains('-open'));
      event.stopImmediatePropagation();
    });
  }

  // Search toggle (mobile)
  const searchButtonMobile = document.querySelector('.header_new-mobile-menu_search_button button');
  if (searchButtonMobile) {
    searchButtonMobile.addEventListener('click', event => {
      if (!mobileMenu.classList.contains('-is-open')) {
        mobileMenu.classList.add('-is-open');
        mobileMenuButton.classList.add('-is-open');
        document.querySelector("html").classList.add('is-header-open');
      }

      mobileMenu.querySelector('.header_new-mobile-menu_search input').focus();
    });
  }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js